import React, { useEffect } from 'react';
import './styles.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAxios } from '../../../hooks/useAxios';
import { ApiCollection } from '../../../config/envConfig';
import SpinnerLoader from '../../../components/loader';

import SubjectHeader from '../../../components/subjectHeader';

const ChapterListView = () => {

  useEffect(() => {
    getChapterList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  const axios = useAxios()
  const [searchParams] = useSearchParams()

  const subjectId = searchParams.get('subjectId');
  const testId = searchParams.get('testId');
  const title = searchParams.get('title');

  const [isLoading, setIsLoading] = React.useState(false);
  const [chapters, setChapters] = React.useState([]);
  const [selectedChapters, setSelectedChapters] = React.useState<string[]>([]);

  const [selectionLimit, setSelectionLimit] = React.useState(1);

  const handleSubmit = async () => {
    // console.log('Selected chapters:', selectedChapters);
    setIsLoading(true);

    await axios.post(ApiCollection.subject.generateQuestionPaper, {
      subject: subjectId,
      test_type: testId,
      chapter: selectedChapters
    })
      .then((response) => {
        // console.log('Question paper generated:', response.data);
        navigate(`/test/instructions?examId=${response.data.exam_id}&title=${title}`);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error generating question paper:', error);
        setIsLoading(false);
      });
  };

  const getChapterList = async () => {
    setIsLoading(true);
    await axios.get(ApiCollection.subject.getChapters, { params: { subject: subjectId, test_type: testId } })
      .then((response) => {
        // console.log(response.data.chapters);
        setChapters(response.data.chapters);
        setSelectionLimit(response.data.selection_limit || 1)
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching subjects:', error);
        setIsLoading(false);
      });
  }

  const handleChapterSelect = (chapterId: string) => {

    if (selectedChapters.length >= selectionLimit && !selectedChapters.includes(chapterId)) {
      return;
    }

    const thisChapter = selectedChapters.find(id => id === chapterId)
    if (thisChapter) {
      setSelectedChapters(selectedChapters.filter(id => id !== chapterId))
    } else {
      setSelectedChapters([...selectedChapters, chapterId])
    }
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', width: '100%' }}>
        <SpinnerLoader />
        <h2 style={{ marginTop: 10, fontSize: 20 }}>
          Loading...
        </h2>
      </div>
    )

  }


  return (
    <div className="chapter_view_screen">



      <div className="chapters_container">
        <SubjectHeader
          title={`Select any ${selectionLimit} Chapter(s)`}
          description={`Pick chapters to generate a question paper for ${title}, you can select upto ${selectionLimit} chapters.`}
        />
        <div className="chapter_grid">
          {chapters.length > 0 ?
            chapters.map((chapter: any) => (
              <div
                key={chapter.id}
                className={`chapter_card ${selectedChapters.includes(chapter.id) ? 'selected' : ''}`}
                onClick={() => handleChapterSelect(chapter.id)}
              >
                <div className="chapter_info">
                  <h3 className="chapter_name">{chapter.title}</h3>
                  <p className="chapter_desc">{chapter.description}</p>
                </div>
              </div>
            ))

            :
            <span>
              No chapters found
            </span>
          }

        </div>
        {
          chapters.length > 12 && <div style={{ marginBottom: 100 }}></div>
        }
        <div className='new_footer chap_list'>
          <button
            className="primary_btn"
            disabled={selectedChapters.length === 0}
            style={{ width: '50%' }}
            onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default ChapterListView;
